import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMount from '../../../../common/hooks/useMount';
import { useTranslation } from 'react-i18next';
import PromoSearch from './components/PromoSearch';
import PromoCard from './components/PromoCard';
import { DiscoverCardTypes } from '../../enums';
import { discoverService } from '../../services/discover';
import {
  BrandDiscoverModel,
  DiscoverProductsModel,
} from '../../models/Discover';
import BannerImg from '../../../../common/assets/images//marketing/discovery-banner.png';
import CashbackImg from '../../../../common/assets/images/marketing/discovery-cashback.jpg';
import VouchersImg from '../../../../common/assets/images/marketing/discovery-vouchers.jpg';
import TaxesImg from '../../../../common/assets/images/marketing/discovery-taxes.jpg';
import ProductsSlideShow from '../Common/ProductsSlideShow';
import { resources } from '../../resources/resources';
import BrandsSlideshow from './components/BrandsSlideShow';
import { brandService } from '../../services/brand';

export default function DiscoverPage() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  const [products, setProducts] = useState<DiscoverProductsModel[]>([]);
  const [brands, setBrands] = useState<BrandDiscoverModel[]>([]);

  const loadProducts = async (abortController?: AbortController) => {
    const result = await discoverService.getProducts({
      signal: abortController?.signal,
    });

    if (!result.hasErrors) {
      setProducts(result.data);
    }
  };

  const loadBrands = async (abortController?: AbortController) => {
    const result = await brandService.getOnlineBrands({
      signal: abortController?.signal,
    });

    if (!result.hasErrors) {
      setBrands(result.data);
    }
  };

  useMount(abortController => {
    loadProducts(abortController);
    loadBrands(abortController);
  });

  return (
    <section className="section-main section-full">
      <div className="container">
        <div className="discover-header">
          <div className="discover-banner">
            <div className="discover-banner-copy">
              <div className="discover-banner-title">
                {translate(resources.discover.marketingCards.banner.title)}
              </div>
              <div className="discover-banner-description">
                {translate(resources.discover.marketingCards.banner.text)}
              </div>
            </div>
            <div className="discover-banner-image">
              <img
                src={BannerImg}
                alt={translate(resources.discover.marketingCards.banner.title)}
              />
            </div>
          </div>
          <div className="discover-search">
            <PromoSearch />
          </div>
        </div>

        <div className="mkt-cards row equal-heights-content discover-mkt-cards">
          <div className="col col-4 col-sm-6 col-xxs-12">
            <PromoCard
              colorClass={'green-card'}
              image={{
                img: CashbackImg,
                alt: translate(resources.discover.marketingCards.cashback),
              }}
              title={translate(resources.discover.marketingCards.cashback)}
              actionName={translate(
                resources.discover.marketingCards.cashbackAction,
              )}
              link={`/club-benefits/${DiscoverCardTypes.Cashback}`}
            />
          </div>
          <div className="col col-4 col-sm-6 col-xxs-12">
            <PromoCard
              colorClass={'blue-card'}
              image={{
                img: VouchersImg,
                alt: translate(resources.discover.marketingCards.vouchers),
              }}
              title={translate(resources.discover.marketingCards.vouchers)}
              actionName={translate(
                resources.discover.marketingCards.vouchersAction,
              )}
              link={`/club-benefits/${DiscoverCardTypes.DiscountVouchers}`}
            />
          </div>
          <div className="col col-4 col-sm-6 col-xxs-12">
            <PromoCard
              colorClass={'red-card'}
              image={{
                img: TaxesImg,
                alt: translate(
                  resources.discover.marketingCards.flexibleBenefits,
                ),
              }}
              title={translate(
                resources.discover.marketingCards.flexibleBenefits,
              )}
              actionName={translate(
                resources.discover.marketingCards.flexibleBenefitsAction,
              )}
              link={'/flexible-benefits'}
            />
          </div>
        </div>
        {brands.length > 0 && (
          <BrandsSlideshow
            title={translate(resources.discover.onlineBrands)}
            brands={brands}
          />
        )}
        {products?.map(discoverModel => {
          if (discoverModel?.products?.length > 0) {
            return (
              <ProductsSlideShow
                key={discoverModel.discoverCategory}
                title={discoverModel.discoverCategory}
                productList={discoverModel.products}
                action={() => navigate(`/discover/${discoverModel.categoryId}`)}
              />
            );
          }
        })}
      </div>
    </section>
  );
}
